import { PublicClientApplication } from '@azure/msal-browser'
import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { configuration } from '../../../app/authConfig'

type PCA = {
  pca: any
}
  
const pcaState: PCA = {
    pca: new PublicClientApplication(configuration)
}

export const pcaSlice = createSlice({
  name: 'pcaSlice',
  initialState: pcaState,
  reducers: {
    changePca: (state, action: PayloadAction<PCA>) => {
     state.pca = action.payload.pca
    }
  }
});

export const { changePca } = pcaSlice.actions